<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-07-06 15:46:18
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-11-28 17:46:00
-->
<template>
  <div class="release-wrapper">
    <div class="release-btn">
      <span @click="$router.go(-1)" class="cancle-btn">取 消</span>
      <van-button :loading="btnLoad" loading-text="发布" @click="handleRelease" type="info" size="small" round style="padding:1px 5px;height:25px;">
        <span class="release-text">发 布</span>
      </van-button>
    </div>
    <div v-title data-title="发布畅聊"></div>
    <div class="release-content">
      <div style="margin-top:10px;">
        <Editor
          ref="editor"
          class="editor"
          v-model="content"
          @onFocus="handleFocus"
          @onCreated="onCreated"
          @onChange="handleEditorChange"
          @customPaste="handleCustomPaste"
          :defaultConfig="editorConfig"
        />
        <Toolbar
          :editor="editor"
          :defaultConfig="{
            toolbarKeys: ['uploadImage', 'emotion', 'insertTopic'],
          }"
        />

      </div>
      <div style="margin-top:20px;" v-if="fileList.length">
        <van-uploader
          v-model="fileList"
          :before-read="beforeRead" />
      </div>
      <div class="show-range" v-if="!deptChecked">
        <div>
          <van-tag
            v-for="item in selectCircle"
            :key="item.id"
            plain
            type="primary"
            style="margin-right:10px;">
            {{item.name}}
          </van-tag>
        </div>
      </div>
      
      <div class="range">
        <div class="sd-bbs-issues-tip">畅聊提示：畅聊板块旨在为京东技术同学提供一个畅所欲言、聊尽技术事的平台。为了营造技术讨论氛围，平台侧不建议用户发表与技术完全无关的无聊话题。期待大家敞开心扉，让技术在不停地交流碰撞中持续进步！</div>
        <div style="display:flex;align-items:center;margin-bottom:14px;">
          <span :class="hasTopic ? 'tips-label' : ''">发布到部门：</span>
          <span v-if="hasTopic" class="tips-wrap"><van-switch disabled size="16" /><span class="tips">部门圈暂不支持话题</span></span>
          <van-switch v-else v-model="deptChecked" size="16" />
        </div>
        <div v-if="deptChecked && !hasTopic" class="dept van-hairline--bottom">
          <van-field
            readonly
            clickable
            class="select-dept"
            name="picker"
            input-align="right"
            :value="selectedDeptText"
            label="选择部门"
            placeholder="点击选择部门"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="deptList"
              @confirm="onConfirmDept"
              @cancel="showPicker = false"
            />
          </van-popup>
        </div>
        <div v-if="!deptChecked || hasTopic" style="display:flex;align-items:center;margin-bottom:5px;">
          <span>发布到圈子：</span>
          <van-switch v-model="checked" @change="handleSwitch" size="16" />
        </div>
        <div v-if="checked && (!deptChecked || hasTopic)" @click="handleCircle" class="circle van-hairline--bottom">
          <span>选择圈子</span>
          <span class="icon">
            <span :style="selectCircle.length ? {color: '#606266'} : {color: '#C0C4CC'}">
              {{selectCircle.length ? `已选择${selectCircle.length}个` : '请选择'}}
            </span>
            <van-icon name="arrow" />
          </span>
        </div>
        <div @click="handleIdentity"  class="circle van-hairline--bottom">
          <span>选择身份</span>
          <span class="icon" style="display:flex;align-items:center;">
            <van-image
              round
              width="0.5rem"
              height="0.5rem"
              :src="selectNameIndex ? avatarList[avatarIndex] : userInfo.avatar"
              />
            <span style="color:#606266;margin-left:5px;">
              {{selectNameIndex ? nameList[avatarIndex] : userInfo.erpName}}
            </span>
            <van-icon name="arrow" color="#606266" />
          </span>
        </div>
      </div>
    </div>
    <van-popup v-model="showCircle" @close="handleRefresh(true)" position="bottom" :style="{ width: '100%', height: '80vh' }">
      <SelectCirclePop />
    </van-popup>
    <van-popup v-model="showTag" position="bottom" :style="{ width: '100%', height: '80vh' }">
      <SelectTagPop ref="labelRef" :checked="checked" />
    </van-popup>
    <van-popup v-model="showName" position="bottom" :style="{ width: '100%', height: '200px' }">
      <div @click="handleChangeName(0)" class="name-item van-hairline--bottom">
        <div class="avatar-item">
          <van-image
            round
            width="0.8rem"
            height="0.8rem"
            :src="userInfo.avatar"
            />
            <span style="margin-left:10px;">{{userInfo.erpName}}</span>
        </div>
        <van-icon v-if="selectNameIndex === 0" name="success" color="#2695F1" />
      </div>
      <div @click="handleChangeName(1)" class="name-item van-hairline--bottom">
        <div class="avatar-item">
          <van-image
            round
            width="0.8rem"
            height="0.8rem"
            :src="avatarList[avatarIndex]"
            />
          <span style="margin-left:10px;">{{nameList[avatarIndex]}}</span>
          <span @click="handleChangeAvatar" style="color:#2695F1;margin-left:10px;font-size:12px;">换一换</span>
        </div>
        <van-icon v-if="selectNameIndex === 1" name="success" color="#2695F1" />
      </div>
    </van-popup>
    <SelectOther
      v-if="showMention"
      @select="handleSelectErp"
      @cancle="hideModal" />
    <SelectTopic
      v-if="showTopic"
      @select="handleSelectTopic"
      @cancel="hideTopicModal" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import SelectCirclePop from './circle.vue'
import SelectTagPop from './label.vue'
import api from '../../api'
import { Toast } from 'vant';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import SelectOther from './../article/components/selectOther.vue';
import SelectTopic from './SelectTopic.vue';

export default {
  data() {
    return {
      checked: false,
      title: '',
      content: '',
      fileList: [],
      showCircle: false,
      showTag: false,
      nameList: [],
      avatarList: [],
      showName: false,
      avatarIndex: 0,
      // 设置为一开始实名
      selectNameIndex: 0,
      btnLoad: false,
      deptList: [],
      btnDis: true,
      selectedDept: null,
      deptChecked: false,
      showPicker: false,
      showMention: false,
      showTopic: false,
      hasTopic: false,
      editor: null,
      editorConfig: {
        placeholder: '有什么想法，快来说几句吧，还可以@其他人呦～',
        autoFocus: true,
        EXTEND_CONF: {
          mentionConfig: {
            showModal: this.showModal, // 必须
            hideModal: this.hideModal, // 必须
          },
          topicConfig: {
            showModal: this.showTopicModal,
            hideModal: this.hideTopicModal,
          }
        },
        MENU_CONF: {
          uploadImage: {
            customUpload: async (file) => {
              const fd = new FormData();
              fd.append('file', file);
              const data = await api.uploadImage(fd);
              if (data.code === 200) {
                this.fileList = [...this.fileList, {
                  url: data?.data?.url
                }]
              }
            },
          },
        },
      },
    }
  },
  components: {
    SelectCirclePop,
    SelectTagPop,
    Editor,
    SelectOther,
    SelectTopic,
    Toolbar
  },
  computed: {
    ...mapState(['selectCircle', 'selectLabel', 'userInfo']),
    selectedDeptText() {
      return this.selectedDept?.text || ''
    },
  },
  created() {
    document.body.scrollTop = document.documentElement.scrollTop = 0
    this.handleBack()
    this.fetchAnonymousName()
    this.fetchAnonymousAvatar()
    this.fetchDeptList();
    this.updateAuthorityTopicList();
    this.updateHotTopicList();
  },
  beforeDestroy() {
    this.updateSelectCircle([])
    this.updateSelectLabel([])
  },
  methods: {
    ...mapMutations(['updateSelectCircle', 'updateSelectLabel']),
    ...mapActions(['updateAuthorityTopicList', 'updateHotTopicList']),
    onCreated(editor) {
      this.editor = Object.seal(editor);
      if (this.$route?.query?.topic) {
        this.initTopic(editor);
      }
    },
    initTopic(_editor = this.editor) {
      const topicNode = {
      type: 'topic',
      children: [{ text: `#${this.$route.query.topic}#` }],
    };
    _editor.insertFragment([{ text: ' ' }]);
    _editor.insertNode(topicNode); // 插入 topic
    _editor.insertFragment([{ text: ' ' }]);
    },
    showModal() {
      this.showMention = true
    },
    hideModal() {
      this.showMention = false
    },
    insertNode(item) {
      const mentionNode = {
        type: 'mention',
        value: item.realName,
        info: item.userName,
        children: [{ text: '' }],
      }
      const editor = this.$refs.editor.editor
      if (editor) {
          editor.restoreSelection() // 恢复选区
          editor.deleteBackward('character') // 删除 '@'
          editor.insertNode(mentionNode) // 插入 mention
          editor.move(1) // 移动光标
      }
    },
    insertTopicNode(item) {
      this.editor.restoreSelection();
      console.log(this.editor.restoreSelection());
      const { focus } = this.editor.selection;
      const text = this.editor.children[focus.path[0]].children[focus.path[1]].text?.slice(
        0,
        focus.offset,
      );
      const topicIndex = text.lastIndexOf('#'); // 当前所在内容中@位置
      const topicNode = {
        type: 'topic',
        children: [{ text: `#${item.content}#` }],
      };

      for (let i = 0; i < focus.offset - topicIndex; i++) {
        this.editor.deleteBackward('character'); // 删除 '#'
      }
      this.editor.insertFragment([{ text: ' ' }]);
      this.editor.insertNode(topicNode); // 插入 topic
      this.editor.insertFragment([{ text: ' ' }]);
    },
    showTopicModal() {
      this.editor.blur();
      this.showTopic = true;
    },
    hideTopicModal() {
      this.showTopic = false;
    },
    handleBack() {
      const _this = this
      let options = {
          disabled: true,
          callback: function() {
            _this.$router.go(-1)
          }
      }
      window.jme.browser.setGoBackDisabled(options)
    },
    async fetchDeptList() {
      const { code, data } = await api.getDept();
      if (code === 200) {
        if (this.$route.query?.deptActive) {
          const selectDept = data.find((item) => +item.orgCode === +this.$route.query?.deptActive);
          if (selectDept) {
            this.deptChecked = true;
            const nameList = selectDept?.name?.split('-');
            this.selectedDept = {
              ...selectDept,
              text: selectDept?.name === '集团T-PaaS' ? selectDept?.name : nameList[nameList.length - 1]
            };
          }
        }
        this.deptList = data.map((item) => {
          const nameList = item.name.split('-');
          return {
            ...item,
            text: item.name === '集团T-PaaS' ? item.name : nameList[nameList.length - 1]
          }
        }) ;
      }
    },
    onConfirmDept(value) {
      this.selectedDept = value;
      this.showPicker = false;
    },
    beforeRead(file) {
      const fd = new FormData();
      fd.append('file', file)
      api.uploadImage(fd).then(res => {
        const { code, data: { url } } = res
        if (code === 200) {
          this.fileList.push({ url })
        }
      })
    },
    handleCircle() {
      this.showCircle = true
    },
    handleTag() {
      this.showTag = true
    },
    handleIdentity() {
      this.showName = true
    },
    handleChangeAvatar() {
      const index = Math.floor(Math.random() * 20)
      this.avatarIndex = index
    },
    handleChangeName(val) {
      this.selectNameIndex = val
    },
    handleFocus() {
      this.scrollTop = document.documentElement.scrollTop
    },
    handleSelectErp(item) {
      this.insertNode(item)
      this.showMention = false
    },
    handleSelectTopic(item) {
      this.insertTopicNode(item);
      this.showTopicModal = false;
    },
    handleCustomPaste(_editor, event, callback) {
      try {
        let html = event.clipboardData.getData('text/html'); // 获取粘贴的 html
        let text = event.clipboardData.getData('text/plain');

        if (html) {
          event.preventDefault();
          _editor.insertText(text);
          callback(false);
        } else {
          callback(true);
        }
      } catch (err) {
        callback(true);
      }
    },
    handleEditorChange(editor) {
      const text = editor.getText().trim()
      this.btnDis = text.length ? false : true;
      if (!editor.selection) return;
      const { focus, anchor } = editor.selection;
      const currentNode = editor.children[focus.path[0]]?.children[focus.path[1]];
      const topicElemList = editor.getElemsByType('topic');
      this.hasTopic = Boolean(topicElemList?.length);
      if (currentNode?.type === 'topic') {
        // 如果删除话题尾部#，则转换为普通文字
        const text = currentNode.children[0]?.text;
        if (!text.endsWith('#')) {
          editor.select({
            anchor: {
              ...anchor,
              offset: 0,
            },
            focus: {
              ...focus,
            },
          });
          editor.deleteFragment();
          editor.insertFragment([{ text }]);
        }
      }
    },
    async handleRelease() {
      const editor = this.$refs.editor.editor;
      if (!editor?.getText()?.trim()) {
        Toast('请输入畅聊内容')
        return
      }
      if (this.deptChecked && !this.selectedDept?.id && !this.hasTopic) {
        Toast('请选择部门')
        return;
      }
      if (!this.selectCircle.length && this.checked && (!this.deptChecked || this.hasTopic)) {
        Toast('请选择圈子')
        return
      }
      // if (!this.selectLabel.length && this.checked) {
      //   Toast('请选择标签')
      //   return
      // }
      let forumIds = this.selectCircle.map(item => item.id)
      // const labels = this.selectLabel.map(item => item.id).join(',')
      if (!forumIds.length) {
        forumIds = [0]
      }
      if (this.deptChecked && !this.hasTopic) {
        forumIds = [this.selectedDept?.id];
      }
      const atUsers = this.editor.getElemsByType('mention')?.map((item) => item.info) || [];
      const params = {
        content: this.content,
        delFlag: 0,
        editorType: 0,
        forumId: forumIds,
        id: 0,
        info: "",
        // labels: labels,
        postAttachmentList: "",
        // title: this.title,
        atUsers,
        type: 1,
        channel: 'h5'
      }
      let chatTopics = [];
      const div = document.createElement('div');
      div.innerHTML = this.content;
      Array.prototype.forEach.call(div.querySelectorAll("[data-w-e-type='topic']"), (elem) => {
        const topicText = elem.innerText.replaceAll('#', '');
        if (topicText) {
          chatTopics.push({
            content: topicText,
            id: 0,
          });
        }
      });
      params.chatTopics = chatTopics;
      if (chatTopics[0] && editor?.getText()?.trim()?.length - chatTopics[0]?.content?.trim()?.length < 7) {
        Toast('请输入话题内容')
        return
      }
      if (this.fileList.length) {
        const imageUrlList = this.fileList.map((item) => item.url);
        params.postAttachmentList = imageUrlList.join(';');
      }
      this.btnLoad = true
      if (this.selectNameIndex === 1) {
        if (this.checked) {
          const data = await api.getCircleBbsIsReal({forumIds : forumIds.join()});
          console.log(data)
          let onlyReal = false;
          for (let key in (data?.data || {})) {
            if (data.data[key]) {
              onlyReal = true;
            }
          }
          if (onlyReal) {
            Toast('所选圈子设置了仅允许实名发布畅聊');
            this.btnLoad = false
            return;
          }
        }
        params.anonymousName = this.nameList[this.avatarIndex]
        params.anonymousAvatar = this.avatarList[this.avatarIndex]
        api.postSaveAnonymous(params).then(res => {
        this.btnLoad = false
        if (res.code === 200) {
          Toast.success('发布成功')
          setTimeout(() => {
            this.$router.push({ name: 'articleList', query: { type: 1, refresh: 1 } })
          }, 1000)
        }
      }).catch(() => {
        this.btnLoad = false
      })
        return;
      }

      api.postSave(params).then(res => {
        this.btnLoad = false
        if (res.code === 200) {
          Toast.success('发布成功')
          setTimeout(() => {
            this.$router.push({ name: 'articleList', query: { type: 1, refresh: 1 } })
          }, 1000)
        }
      }).catch(() => {
        this.btnLoad = false
      })
    },
    handleSwitch(val) {
      this.handleRefresh(val)
      this.updateSelectLabel([])
      this.updateSelectCircle([])
    },
    handleRefresh(val) {
      this.$refs.labelRef && this.$refs.labelRef.init(val)
    },
    fetchAnonymousName() {
      api.getAnonymousName().then(res => {
        const { code, data } = res
        if (code === 200) {
          this.nameList = data
        }
      })
    },
    fetchAnonymousAvatar() {
      api.getAnonymousAvatar().then(res => {
        const { code, data } = res
        if (code === 200) {
          this.avatarList = data
        }
      })
    }
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.release-wrapper {
  background: #fff;
  height: 100vh;
  padding: 20px;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  /deep/ .w-e-panel-content-emotion {
    width: 260px;
  } 
  /deep/ .w-e-text-container {
    min-height: 80px;
  }
  .range {
    // margin-top: 20px;
    color: #606266;
  }
  .circle, .dept {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
  }
  // .dept::after {
  //   display: none;
  // }
  .icon {
    color: #C0C4CC;
  }
  .add-btn {
    flex-shrink: 0;
  }
  .rank {
    color: #323233;
  }
  .tag-item {
    display: flex;
    justify-content: space-between;
    padding: 15px 30px;
  }
  .release-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    position: sticky;
    background: #fff;
    z-index: 100;
    top: 0;
  }
  .release-content {
    height: calc(100vh - 40px);
    overflow-y: auto;
    overflow-x: hidden;
  }
  .show-range {
    margin-top: 10px;
  }
  .name-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 30px 10px 20px;
  }
  .avatar-item {
    display: flex;
    align-items: center;
  }
  .cancle-btn {
    font-size: 16px;
    font-weight: 500;
    color: #8F959E;
  }
  .release-text {
    font-size: 16px;
    font-weight: 500;
    display: inline-block;
    padding: 1px 5px;
  }
  .sd-bbs-issues-tip {
    color: #f5bc82;
    font-size: 12px;
    background: #fffaf5;
    border-radius: 4px;
    padding: 4px 8px;
    margin-bottom: 10px;
  }
}
.select-dept {
  padding: 0;
  &::after {
    display: none;
  }
}
.tips-wrap {
  display: flex;
  align-items: center;
}
.tips {
  font-size: 12px;
  color: #848484;
  transform: scale(0.9);
  margin-left: 12px;
}
.tips-label {
  color: #bbb;
}
</style>